import {Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";

@Component({
  selector: 'app-gallery-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './gallery-edit.component.html',
  styleUrl: './gallery-edit.component.scss'
})
export class GalleryEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected crudService: CrudService) {

  }

  editLink = '/dashboard/gallery-edit/';
  menuLink = '/dashboard/gallery';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'gallery';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {
        img_left: null,
        img_right: null,
      } as any;
    }
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'Images',
        configs: [
          {field: 'img_left', name: 'Image Left', type: EInputType.FILE_PREVIEW, validators: []},
          {field: 'img_right', name: 'Image Right', type: EInputType.FILE_PREVIEW, validators: []},
        ]
      },
      {
        name: 'En',
        configs: [
          {field: 'title_left_en', name: 'Title Left En', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'desc_left_en', name: 'Desc Left En', type: EInputType.TEXTAREA, validators: []},
          {field: 'desc_right_en', name: 'Desc Right En', type: EInputType.TEXTAREA, validators: []},
        ]
      },
      {
        name: 'Es',
        configs: [
          {field: 'title_left_es', name: 'Title Es', type: EInputType.TEXT, validators: [Validators.required]},
          {field: 'desc_left_es', name: 'Desc Es', type: EInputType.TEXTAREA, validators: []},
          {field: 'desc_right_es', name: 'Desc Es', type: EInputType.TEXTAREA, validators: []},
        ]
      },
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (gallery ' + item.name + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
